<template>
    <!-- DESCR：会议列表的视图页面 -->
    <div class="conferencelist-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="24" class="login-title">
                <div class="desc-box">
                    <div class="title">My conferences</div>
                    <br />
                    <div class="info">
                        This page displays the meetings you have participated in in ConfChair
                    </div>
                    <div class="info">
                        If you want to view your character, please use the context menu in the upper right corner
                    </div>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="21">
                <div class="click-tips">
                    <span class="text-line">To access a conference, click on its acronym，Color explanation: </span>
                    <div><el-tag style="margin-right:10px;">active conference</el-tag><el-tag type="danger">expired conference</el-tag></div>
                </div>
                <el-table :data="conferenceMyList" style="width: 100%" border :row-class-name="tableRowClassName" @row-click="loginconf">
                    <el-table-column label="Id" width="100" align="center">
                        <template #default="scope">
                            <span style="margin-left: 10px">{{ scope.row.id }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="Acronym" width="130" align="center">
                        <template #default="scope">
                            <el-text class="mx-1" type="primary" size="small">{{ scope.row.acronym }}</el-text>
                            <!-- <el-tag type="success">{{ scope.row.acronym }}</el-tag> -->
                        </template>
                    </el-table-column>
                    <el-table-column label="Name" prop="Name" align="center">
                        <template #default="scope">
                            <el-tag>{{ scope.row.title }}</el-tag>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from "vue";
import { useRouter } from "vue-router";
import { TopRight, Money, DocumentCopy, Files, Search, ArrowRight,ArrowLeftBold } from '@element-plus/icons-vue'
import request from "../../network/request"


const router = useRouter()

// 我参与的论文列表
const conferenceMyList = ref([])

function isBeforeDate(dateString) {
     // 获取当前日期
     var currentDate = new Date();
    // 将当前日期的时间部分设置为 0，以便只比较日期
    currentDate.setHours(0, 0, 0, 0);
    
    // 将日期字符串转换为日期对象
    var targetDate = new Date(dateString);
    // 将目标日期的时间部分设置为 0，以便只比较日期
    targetDate.setHours(0, 0, 0, 0);
    
    // 比较当前日期是否小于等于目标日期
    return currentDate <= targetDate;
}

// 排序
function sortConferenceByCreateTime() {
    conferenceMyList.value.sort((a, b) => {
        const timeA = new Date(a.createtime).getTime();
        const timeB = new Date(b.createtime).getTime();
        return timeB - timeA;
    });
}

// 获取我参与的会议列表
function getConferenceMyList() {
    request.get(`/conference/joinlist`).then((res) => {
        conferenceMyList.value = res.data;
        sortConferenceByCreateTime()
    })
}

// 我的会议列表表格行样式
const tableRowClassName = ({ row, rowIndex, }) => {
    if (isBeforeDate(row.lastday)) {
        return 'success-row'
    }
    else {
        return 'warning-row'
    }
}

// 以主席身份进入
const loginconf = (row, column, event) => {
    router.push(`/common/conferencelogin?cid=${row.cid}&acronym=${row.acronym}&title=${row.title}&subnum=${row.subnum}`)
}


onMounted(() => {
    // 获取我参与过的会议
    getConferenceMyList();
})
</script>

<style lang="scss">
.conferencelist-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }
    .click-tips{
        font-size: 13px;
        .text-line{
            border-bottom: 1px solid #88b5cb61;
            display: inline-block;
            margin-bottom: 20px;
            padding-bottom: 5px;
        }
        div{
            margin-bottom: 10px;
        }
    }
    .el-table .warning-row {
        background-color: #ffd1d11c;
        cursor: pointer;
    }

    .el-table .success-row {
        background-color: #a2d2d714;
        cursor: pointer;
    }
}
</style>